import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-900 py-8 sm:py-12 px-4" }
const _hoisted_2 = { class: "max-w-4xl mx-auto" }
const _hoisted_3 = { class: "bg-gray-800 rounded-xl p-4 sm:p-6 mb-6 sm:mb-8" }
const _hoisted_4 = { class: "flex justify-between items-center mb-4" }
const _hoisted_5 = { class: "text-lg sm:text-xl font-semibold text-white" }
const _hoisted_6 = {
  key: 0,
  class: "mt-1 text-sm text-red-500 flex items-center"
}
const _hoisted_7 = { class: "w-full px-3 sm:px-4 py-2 bg-gray-700/50 rounded-lg text-gray-400 border border-gray-600/50 font-mono text-sm break-all" }
const _hoisted_8 = {
  key: 0,
  class: "mt-1 text-sm text-red-500"
}
const _hoisted_9 = {
  key: 0,
  class: "mt-1 text-sm text-red-500 flex items-center"
}
const _hoisted_10 = { class: "space-y-2" }
const _hoisted_11 = ["onUpdate:modelValue"]
const _hoisted_12 = ["onClick", "disabled"]
const _hoisted_13 = {
  key: 0,
  class: "mt-2 text-sm text-red-500 flex items-center"
}
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "bg-gray-800 rounded-xl p-4 sm:p-6" }
const _hoisted_16 = { class: "flex items-center justify-between mb-6" }
const _hoisted_17 = { class: "flex items-center gap-3" }
const _hoisted_18 = ["disabled", "title"]
const _hoisted_19 = { class: "text-sm text-gray-400" }
const _hoisted_20 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_21 = { class: "p-4 bg-gray-700/50" }
const _hoisted_22 = { class: "flex items-start justify-between" }
const _hoisted_23 = { class: "flex-1 min-w-0 mr-4" }
const _hoisted_24 = { class: "text-white font-medium text-lg mb-1 truncate" }
const _hoisted_25 = { class: "flex items-center text-gray-400 text-sm" }
const _hoisted_26 = { class: "truncate" }
const _hoisted_27 = { class: "flex gap-1" }
const _hoisted_28 = ["href"]
const _hoisted_29 = { class: "grid grid-cols-4 divide-x divide-gray-600/20 bg-gray-700/30" }
const _hoisted_30 = { class: "px-3 py-3 text-center" }
const _hoisted_31 = { class: "text-lg font-semibold text-amber-400" }
const _hoisted_32 = { class: "px-3 py-3 text-center" }
const _hoisted_33 = { class: "text-lg font-semibold text-blue-400" }
const _hoisted_34 = { class: "px-3 py-3 text-center" }
const _hoisted_35 = { class: "text-lg font-semibold text-green-400" }
const _hoisted_36 = { class: "px-3 py-3 text-center" }
const _hoisted_37 = { class: "text-lg font-semibold text-purple-400" }
const _hoisted_38 = { class: "p-4 bg-gray-700/20 flex items-center justify-between" }
const _hoisted_39 = { class: "text-xs text-gray-400" }
const _hoisted_40 = { class: "font-mono" }
const _hoisted_41 = { class: "flex items-center gap-2" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = ["onClick", "disabled", "title"]
const _hoisted_44 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-4 w-4",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_45 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-4 w-4 animate-spin",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_46 = {
  key: 0,
  class: "text-center py-12"
}

import { ref, onMounted } from 'vue'
import { db, functions } from '@/config/firebase'
import { collection, getDocs, onSnapshot, query, where, getCountFromServer, doc, updateDoc, deleteDoc } from 'firebase/firestore'
import { httpsCallable } from 'firebase/functions'


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateDemoView',
  setup(__props) {

const setupDemo = httpsCallable(functions, 'setupDemo')
const editingDemo = ref<any>(null)
const isEditing = ref(false)
const isDeleting = ref(false)
const isRefreshing = ref(false)
const deletingDemos = ref<string[]>([])

const refreshAllMetrics = async () => {
  if (isRefreshing.value) return
  
  isRefreshing.value = true
  try {
    // Update all demos in parallel
    const updatedDemos = await Promise.all(
      demos.value.map(async (demo) => {
        const counts = await getCounts(demo.id)
        return {
          ...demo,
          search_count: counts.searches,
          product_count: counts.products,
          enriched_count: counts.enriched
        }
      })
    )
    demos.value = updatedDemos
  } catch (error) {
    console.error('Error refreshing metrics:', error)
  } finally {
    isRefreshing.value = false
  }
}

const confirmDelete = async (demo: any) => {
  if (!confirm(`Are you sure you want to delete the demo "${demo.name}"? This action cannot be undone.`)) {
    return;
  }

  deletingDemos.value.push(demo.id);
  try {
    // Delete the demo document
    const demoRef = doc(db, 'demos', demo.id);
    await deleteDoc(demoRef);

    // Delete related demo-searches
    const searchesRef = collection(db, 'demo-searches');
    const searchesQuery = query(searchesRef, where('org_id', '==', demo.id));
    const searchesSnapshot = await getDocs(searchesQuery);
    const searchDeletePromises = searchesSnapshot.docs.map(doc => deleteDoc(doc.ref));
    await Promise.all(searchDeletePromises);

    // Delete related demo-products
    const productsRef = collection(db, 'demo-products');
    const productsQuery = query(productsRef, where('org_id', '==', demo.id));
    const productsSnapshot = await getDocs(productsQuery);
    const productDeletePromises = productsSnapshot.docs.map(doc => deleteDoc(doc.ref));
    await Promise.all(productDeletePromises);

  } catch (error) {
    console.error('Error deleting demo:', error);
    alert('Failed to delete demo. Please try again.');
  } finally {
    deletingDemos.value = deletingDemos.value.filter(id => id !== demo.id);
  }
}

const demos = ref<any[]>([])
const isLoading = ref(false)
const newDemo = ref({
  id: '',
  name: '',
  shopify_domain: '',
  questions: [''] // Initialize with one empty question
})

const errors = ref({
  id: '',
  name: '',
  shopify_domain: '',
  questions: ''
})

const validateDomain = (domain: string) => {
  if (!domain) return 'Domain is required'
  if (domain.endsWith('/')) return 'Domain should not end with /'
  // Basic domain validation - must have at least one dot and no spaces
  if (!domain.includes('.') || domain.includes(' ')) return 'Please enter a valid domain (e.g., example.com)'
  return ''
}

const validateDemoName = (name: string) => {
  if (!name) return 'Demo name is required'
  if (name.length < 3) return 'Demo name must be at least 3 characters long'
  if (name.length > 50) return 'Demo name must be less than 50 characters'
  return ''
}

const validateQuestions = (questions: string[]) => {
  const nonEmptyQuestions = questions.filter(q => q.trim())
  // If there are any non-empty questions, validate their length
  if (nonEmptyQuestions.length > 0 && questions.some(q => q.trim().length > 0 && q.trim().length < 10)) {
    return 'Questions must be at least 10 characters long'
  }
  return ''
}

const handleize = (str: string) => {
  return str
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
};

const updateDemoId = () => {
  if (!isEditing && newDemo.value.name) {
    newDemo.value.id = handleize(newDemo.value.name);
  }
};

const validateFields = () => {
  // Always set the ID from the name before validation
  if (!isEditing && newDemo.value.name) {
    newDemo.value.id = handleize(newDemo.value.name);
  }

      errors.value = {
    id: !newDemo.value.name ? 'Demo name is required to generate ID' : '',
    name: validateDemoName(newDemo.value.name),
    shopify_domain: validateDomain(newDemo.value.shopify_domain),
    questions: validateQuestions(newDemo.value.questions)
  }

  return !Object.values(errors.value).some(error => error);
};

// Get counts for a demo
const getCounts = async (demoId: string) => {
  const searchesRef = collection(db, 'demo-searches')
  const searchQuery = query(searchesRef, where('org_id', '==', demoId))
  const searchSnapshot = await getCountFromServer(searchQuery)

  const productsRef = collection(db, 'demo-products')
  const productsQuery = query(productsRef, where('org_id', '==', demoId))
  const productsSnapshot = await getCountFromServer(productsQuery)

  // Count enriched products (those with embeddings)
  const enrichedQuery = query(
    productsRef, 
    where('org_id', '==', demoId),
    where('embedding', '!=', null)
  )
  const enrichedSnapshot = await getCountFromServer(enrichedQuery)

  return {
    searches: searchSnapshot.data().count,
    products: productsSnapshot.data().count,
    enriched: enrichedSnapshot.data().count
  }
}

// Load demos and listen for updates
onMounted(() => {
  const demosRef = collection(db, 'demos')
  onSnapshot(demosRef, async (snapshot) => {
    // Get demos with their counts
    const demosWithCounts = await Promise.all(
      snapshot.docs.map(async doc => {
        const counts = await getCounts(doc.id)
        return {
          id: doc.id,
          ...doc.data(),
          search_count: counts.searches,
          product_count: counts.products,
          enriched_count: counts.enriched
        }
      })
    )
    demos.value = demosWithCounts
  })
})

const addQuestion = () => {
  newDemo.value.questions.push('')
}

const removeQuestion = (index: number) => {
  if (newDemo.value.questions.length > 1) {
    newDemo.value.questions.splice(index, 1)
  }
}

const startEdit = (demo: any) => {
  editingDemo.value = { ...demo }
  isEditing.value = true
  newDemo.value = {
    id: demo.id,
    name: demo.name,
    shopify_domain: demo.shopify_domain,
    questions: [...(demo.questions || [''])]
  }
}

const cancelEdit = () => {
  isEditing.value = false
  editingDemo.value = null
  newDemo.value = {
    id: '',
    name: '',
    shopify_domain: '',
    questions: ['']
  }
  errors.value = {
    id: '',
    name: '',
    shopify_domain: '',
    questions: ''
  }
}

const updateDemo = async () => {
  if (!validateFields()) return

  isLoading.value = true
  try {
    const demoRef = doc(db, 'demos', newDemo.value.id)
    const questions = newDemo.value.questions.filter(q => q.trim() !== '');
    await updateDoc(demoRef, {
      name: newDemo.value.name,
      shopify_domain: newDemo.value.shopify_domain,
      questions: questions
    })
    
    // Reset form
    cancelEdit()
  } catch (error) {
    console.error('Error updating demo:', error)
    alert('Failed to update demo. Please try again.')
  } finally {
    isLoading.value = false
  }
}

const createDemo = async () => {
  // Ensure ID is set from name before validation
  if (newDemo.value.name) {
    newDemo.value.id = handleize(newDemo.value.name);
  }

  if (!validateFields()) return

  isLoading.value = true
  try {
    const filteredQuestions = newDemo.value.questions.filter(q => q.trim() !== '');
    console.log('Creating demo with ID:', newDemo.value.id); // Debug log
    const result = await setupDemo({
      id: handleize(newDemo.value.name), // Ensure we use fresh handleized version
      name: newDemo.value.name,
      shopify_domain: newDemo.value.shopify_domain.trim(),
      questions: filteredQuestions
    })

    const response = result.data as { success: boolean; message?: string };
    if (!response.success) {
      throw new Error(response.message || 'Failed to create demo');
    }
    
    // Reset form
    newDemo.value = {
      id: '',
      name: '',
      shopify_domain: '',
      questions: ['']
    }
    errors.value = {
      id: '',
      name: '',
      shopify_domain: '',
      questions: ''
    }
  } catch (error) {
    console.error('Error creating demo:', error)
    alert('Failed to create demo. Please try again.')
  } finally {
    isLoading.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[26] || (_cache[26] = _createElementVNode("h1", { class: "text-2xl sm:text-3xl font-bold text-white mb-6 sm:mb-8" }, "Demo Management", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(isEditing.value ? 'Edit Demo' : 'Create New Demo'), 1),
          (isEditing.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: cancelEdit,
                class: "text-gray-400 hover:text-gray-300 text-sm px-3 py-1 hover:bg-gray-700 rounded-md transition-colors duration-200"
              }, " Cancel Edit "))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("form", {
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (isEditing.value ? updateDemo() : createDemo()), ["prevent"])),
          class: "space-y-4"
        }, [
          _createElementVNode("div", null, [
            _cache[4] || (_cache[4] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-300 mb-1" }, "Demo Name", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newDemo.value.name) = $event)),
              type: "text",
              onInput: updateDemoId,
              placeholder: "e.g., Super Sleeper",
              class: _normalizeClass([
                'w-full px-3 sm:px-4 py-2 bg-gray-700 rounded-lg text-white placeholder-gray-400 border focus:ring-2 focus:outline-none transition-colors duration-200 text-sm sm:text-base',
                errors.value.name ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : 'border-gray-600 focus:border-blue-500 focus:ring-blue-500'
              ])
            }, null, 34), [
              [_vModelText, newDemo.value.name]
            ]),
            (errors.value.name)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                  _cache[3] || (_cache[3] = _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    class: "h-4 w-4 mr-1.5 flex-shrink-0",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    })
                  ], -1)),
                  _createTextVNode(" " + _toDisplayString(errors.value.name), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "flex justify-between items-center mb-1" }, [
              _createElementVNode("label", { class: "text-sm font-medium text-gray-300" }, "Demo ID"),
              _createElementVNode("span", { class: "text-xs text-gray-500" }, "Auto-generated from name")
            ], -1)),
            _createElementVNode("div", _hoisted_7, _toDisplayString(newDemo.value.name ? handleize(newDemo.value.name) : 'demo-id-preview'), 1),
            (errors.value.id)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(errors.value.id), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            _cache[7] || (_cache[7] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-300 mb-1" }, "Domain", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newDemo.value.shopify_domain) = $event)),
              type: "text",
              placeholder: "e.g., example.com",
              class: _normalizeClass([
                'w-full px-3 sm:px-4 py-2 bg-gray-700 rounded-lg text-white placeholder-gray-400 border focus:ring-2 focus:outline-none transition-colors duration-200 text-sm sm:text-base',
                errors.value.shopify_domain ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : 'border-gray-600 focus:border-blue-500 focus:ring-blue-500'
              ])
            }, null, 2), [
              [_vModelText, newDemo.value.shopify_domain]
            ]),
            (errors.value.shopify_domain)
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                  _cache[6] || (_cache[6] = _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    class: "h-4 w-4 mr-1.5 flex-shrink-0",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    })
                  ], -1)),
                  _createTextVNode(" " + _toDisplayString(errors.value.shopify_domain), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "flex justify-between items-center mb-1" }, [
              _createElementVNode("label", { class: "text-sm font-medium text-gray-300" }, "Quick Search Questions"),
              _createElementVNode("span", { class: "text-xs text-gray-500" }, "Optional")
            ], -1)),
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newDemo.value.questions, (question, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "flex gap-2"
                }, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": ($event: any) => ((newDemo.value.questions[index]) = $event),
                    type: "text",
                    placeholder: 'e.g., What mattress is best for back pain?',
                    class: _normalizeClass([
                    'flex-1 px-3 sm:px-4 py-2 bg-gray-700 rounded-lg text-white placeholder-gray-400 border focus:ring-2 focus:outline-none transition-colors duration-200 text-sm sm:text-base',
                    errors.value.questions && (!question.trim() || question.trim().length < 10) ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : 'border-gray-600 focus:border-blue-500 focus:ring-blue-500'
                  ])
                  }, null, 10, _hoisted_11), [
                    [_vModelText, newDemo.value.questions[index]]
                  ]),
                  _createElementVNode("button", {
                    onClick: ($event: any) => (removeQuestion(index)),
                    type: "button",
                    class: "p-2 text-red-400 hover:text-red-300 hover:bg-gray-600/50 rounded-lg transition-colors duration-200",
                    disabled: newDemo.value.questions.length === 1
                  }, _cache[8] || (_cache[8] = [
                    _createElementVNode("svg", {
                      xmlns: "http://www.w3.org/2000/svg",
                      class: "h-5 w-5",
                      fill: "none",
                      viewBox: "0 0 24 24",
                      stroke: "currentColor"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                      })
                    ], -1)
                  ]), 8, _hoisted_12)
                ]))
              }), 128))
            ]),
            _createElementVNode("button", {
              onClick: addQuestion,
              type: "button",
              class: "mt-2 text-blue-400 hover:text-blue-300 hover:bg-blue-500/10 transition-colors duration-200 text-sm flex items-center px-3 py-1.5 rounded-lg"
            }, _cache[9] || (_cache[9] = [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: "h-4 w-4 mr-1.5",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M12 4v16m8-8H4"
                })
              ], -1),
              _createTextVNode(" Add another question ")
            ])),
            (errors.value.questions)
              ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
                  _cache[10] || (_cache[10] = _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    class: "h-4 w-4 mr-1.5 flex-shrink-0",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    })
                  ], -1)),
                  _createTextVNode(" " + _toDisplayString(errors.value.questions), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("button", {
            type: "submit",
            disabled: isLoading.value,
            class: "w-full px-4 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed text-sm sm:text-base mt-6"
          }, _toDisplayString(isLoading.value ? (isEditing.value ? 'Updating...' : 'Creating...') : (isEditing.value ? 'Update Demo' : 'Create Demo')), 9, _hoisted_14)
        ], 32)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _cache[14] || (_cache[14] = _createElementVNode("h2", { class: "text-xl font-semibold text-white" }, "Existing Demos", -1)),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("button", {
              onClick: refreshAllMetrics,
              disabled: isRefreshing.value,
              class: "p-1.5 text-gray-400 hover:text-gray-300 hover:bg-gray-600/50 rounded-lg transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2",
              title: isRefreshing.value ? 'Refreshing metrics...' : 'Refresh all metrics'
            }, [
              (_openBlock(), _createElementBlock("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: _normalizeClass(["h-4 w-4", { 'animate-spin': isRefreshing.value }]),
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }, _cache[12] || (_cache[12] = [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                }, null, -1)
              ]), 2)),
              _cache[13] || (_cache[13] = _createElementVNode("span", { class: "text-sm" }, "Refresh", -1))
            ], 8, _hoisted_18),
            _createElementVNode("div", _hoisted_19, _toDisplayString(demos.value.length) + " demo" + _toDisplayString(demos.value.length !== 1 ? 's' : ''), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(demos.value, (demo) => {
            return (_openBlock(), _createElementBlock("div", {
              key: demo.id,
              class: "bg-gradient-to-br from-gray-700 to-gray-700/50 rounded-xl overflow-hidden border border-gray-600/20 hover:border-gray-500/30 transition-all duration-300"
            }, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("h3", _hoisted_24, _toDisplayString(demo.name), 1),
                    _createElementVNode("div", _hoisted_25, [
                      _cache[15] || (_cache[15] = _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        class: "h-4 w-4 mr-1.5",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"
                        })
                      ], -1)),
                      _createElementVNode("span", _hoisted_26, _toDisplayString(demo.shopify_domain), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("a", {
                      href: '/demos/' + demo.id,
                      target: "_blank",
                      class: "text-blue-400 hover:text-blue-300 transition-colors duration-200 p-1.5 hover:bg-gray-600/50 rounded-lg",
                      title: "View Demo"
                    }, _cache[16] || (_cache[16] = [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        class: "h-5 w-5",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                        }),
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                        })
                      ], -1)
                    ]), 8, _hoisted_28)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, _toDisplayString(demo.views || 0), 1),
                  _cache[17] || (_cache[17] = _createElementVNode("div", { class: "text-xs text-gray-400 mt-0.5" }, "Views", -1))
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, _toDisplayString(demo.search_count || 0), 1),
                  _cache[18] || (_cache[18] = _createElementVNode("div", { class: "text-xs text-gray-400 mt-0.5" }, "Searches", -1))
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, _toDisplayString(demo.product_count || 0), 1),
                  _cache[19] || (_cache[19] = _createElementVNode("div", { class: "text-xs text-gray-400 mt-0.5" }, "Products", -1))
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, _toDisplayString(demo.enriched_count || 0), 1),
                  _cache[20] || (_cache[20] = _createElementVNode("div", { class: "text-xs text-gray-400 mt-0.5" }, "Enriched", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _cache[21] || (_cache[21] = _createTextVNode(" ID: ")),
                  _createElementVNode("span", _hoisted_40, _toDisplayString(demo.id), 1)
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("button", {
                    onClick: ($event: any) => (startEdit(demo)),
                    class: "text-gray-400 hover:text-yellow-300 transition-colors duration-200 p-1.5 hover:bg-gray-600/50 rounded-lg group",
                    title: "Edit Demo"
                  }, _cache[22] || (_cache[22] = [
                    _createElementVNode("svg", {
                      xmlns: "http://www.w3.org/2000/svg",
                      class: "h-4 w-4",
                      fill: "none",
                      viewBox: "0 0 24 24",
                      stroke: "currentColor"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                      })
                    ], -1)
                  ]), 8, _hoisted_42),
                  _createElementVNode("button", {
                    onClick: ($event: any) => (confirmDelete(demo)),
                    disabled: deletingDemos.value.includes(demo.id),
                    class: "text-gray-400 hover:text-red-400 transition-colors duration-200 p-1.5 hover:bg-gray-600/50 rounded-lg group disabled:opacity-50 disabled:cursor-not-allowed",
                    title: deletingDemos.value.includes(demo.id) ? 'Deleting...' : 'Delete Demo'
                  }, [
                    (!deletingDemos.value.includes(demo.id))
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_44, _cache[23] || (_cache[23] = [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                          }, null, -1)
                        ])))
                      : (_openBlock(), _createElementBlock("svg", _hoisted_45, _cache[24] || (_cache[24] = [
                          _createElementVNode("circle", {
                            class: "opacity-25",
                            cx: "12",
                            cy: "12",
                            r: "10",
                            stroke: "currentColor",
                            "stroke-width": "4"
                          }, null, -1),
                          _createElementVNode("path", {
                            class: "opacity-75",
                            fill: "currentColor",
                            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          }, null, -1)
                        ])))
                  ], 8, _hoisted_43)
                ])
              ])
            ]))
          }), 128))
        ]),
        (demos.value.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_46, _cache[25] || (_cache[25] = [
              _createElementVNode("div", { class: "text-gray-400 mb-2" }, "No demos created yet", -1),
              _createElementVNode("div", { class: "text-sm text-gray-500" }, "Create your first demo using the form above", -1)
            ])))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})